import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
    methods: {
        /**
         * @param slots
         * @return {object}
         */
        getHiringEventSlots(slots) {

            const userTimezone = dayjs.tz.guess();

            const slots_data = (slots || []).map(incomingSlot => {
                const startTime = dayjs
                .tz(`${incomingSlot.date} ${incomingSlot.start_time}:00`, incomingSlot.timezone)
                .tz(userTimezone);
                const endTime = incomingSlot.end_time ? dayjs
                .tz(`${incomingSlot.date} ${incomingSlot.end_time}:00`, incomingSlot.timezone)
                .tz(userTimezone) : null;

                // Formatting original times without timezone conversion
                const originalStartTime12Hour = dayjs(`${incomingSlot.date} ${incomingSlot.start_time}:00`)
                .format('h:mm A'); // 12-hour format
                const originalEndTime12Hour = incomingSlot.end_time ? dayjs(`${incomingSlot.date} ${incomingSlot.end_time}:00`)
                    .format('h:mm A') : null;

                return {
                original: incomingSlot,
                id: incomingSlot.id,
                dayjsStartDate: startTime,
                date: startTime.format('MM-DD-YYYY'),
                startTime: startTime.format('h:mm A'),
                endTime: endTime ? endTime.format('h:mm A') : null,
                full: incomingSlot.full,
                originalStartTime12Hour, // Original start time in 12-hour format
                originalEndTime12Hour, // Original end time in 12-hour format
                };
            })
            .sort((s1, s2) =>
                s1.dayjsStartDate.unix() - s2.dayjsStartDate.unix());
            return slots_data;
        }
    }
}
